{
  "info": "Informácie",
  "negative": "Chyba",
  "notice": "Upozornenie",
  "positive": "Úspech"
}
